// Per-browser UI conveniences in localStorage (open blocks, chosen periods). Storage may be blocked
// or cleared: every read falls back to the default, every write may silently fail.

export function readUiState(key, fallback) {
  try {
    const raw = window.localStorage.getItem(key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function writeUiState(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Blocked storage: the choice lasts until reload
  }
}
